export const DATA = {
  hours: {
    checkin: '14:00', checkout: '12:00', breakfastStart: '07:00', breakfastEnd: '10:30',
    laundryStart: '07:00', laundryEnd: '17:00', laundryCutoff: '12:00',
    roomServiceStart: '07:00', roomServiceEnd: '21:00', quietStart: '22:00', quietEnd: '08:00'
  },

  contact: {
    address: 'Largo de Coimbra, 38 — Ouro Preto, MG', phone: '+55 (31) 3552-7700',
    whatsapp: '+55 (31) 99164-0648', email: 'reservas@mondego.com.br'
  },

  extensionsRooms: ['100', '101', '102', '103', '104', '105', '106', '107', '208', '209', '310', '311', '312',
    '314', '315', '316', '317', '318', '319', '320', '321', '422', '423', '524'],

  extensionsCommon: [
    { key: 'reception', ext: ['09'] },
    { key: 'reservations', ext: ['264'] },
    { key: 'pantry', ext: ['238'] }
  ],

  laundry: [
    { key: 'blazerLinen', wash: 75, iron: 40 },
    { key: 'blazerJacket', wash: 55, iron: 20 },
    { key: 'blouseLS', wash: 22, iron: 11 },
    { key: 'woolBlouse', wash: 30, iron: 15 },
    { key: 'shorts', wash: 25, iron: 10 },
    { key: 'delicates', wash: 15, iron: 7.5 },
    { key: 'jeans', wash: 25, iron: 15 },
    { key: 'socialPants', wash: 30, iron: 18 },
    { key: 'socialShirt', wash: 20, iron: 18 },
    { key: 'tshirt', wash: 20, iron: 11 },
    { key: 'nightgown', wash: 55, iron: 11 },
    { key: 'jacket', wash: 45, iron: 22 },
    { key: 'jumpsuitDress', wash: 30, iron: 25 },
    { key: 'shortPajama', wash: 26, iron: 18 },
    { key: 'longPajama', wash: 25, iron: 15 },
    { key: 'skirtLong', wash: 100, iron: 13 },
    { key: 'tuxedoSuit', wash: null, iron: 50 },
    { key: 'sneakers', wash: 25, iron: null },
    { key: 'linenSuit', wash: 100, iron: 50 },
    { key: 'silkDress', wash: 55, iron: 40 },
    { key: 'socialDress', wash: 100, iron: 70 }
  ],

  minibarDrinks: [
    { key: 'sparklingWater', price: 5 },
    { key: 'stillWater', price: 5 },
    { key: 'longneckBeer', price: 10 },
    { key: 'sodaCan', price: 6 },
    { key: 'fruitJuiceBox', price: 8 },
    { key: 'grapeJuice', price: 20 }
  ],
  minibarAlcohol: [
    { key: 'vodka', price: 15 },
    { key: 'whiskyJimBeam', price: 20 },
    { key: 'whiskyRedLabel', price: 22 }
  ],
  minibarWine: [
    { key: 'merlot187', price: 40 },
    { key: 'lomaNegra', price: 50 }
  ],
  sparkling: [
    { key: 'brutBranco', price: 89.90 },
    { key: 'reservaMoscatel', price: 89.90 },
    { key: 'portoNero', price: 118 }
  ],
  beers: [
    { key: 'heineken', price: 10 },
    { key: 'stellaArtois', price: 10 }
  ],
  wineWhite: [
    { key: 'gewurztraminer', price: 160 }
  ],
  wineRed: [
    { key: 'elegance', price: 160 },
    { key: 'chileCabSauv', price: 160 },
    { key: 'merlot750', price: 140 },
    { key: 'carmenere', price: 160 },
    { key: 'naturelle', price: 135 },
    { key: 'merlot187b', price: 40 }
  ],
  corkage: 50,
  roomService: { breakfast: 80, teaSimple: 25, cheeseBread: 30, hotBeverageJug: 10, freshJuice: 10 }
};

export function money(n) {
  if (n === null || n === undefined) return null;
  return 'R$ ' + n.toFixed(2).replace('.', ',');
}

export const LANGS = ['pt', 'en', 'es', 'de', 'fr', 'it'];
export const FLAGS = { pt: '🇧🇷', en: '🇺🇸', es: '🇪🇸', de: '🇩🇪', fr: '🇫🇷', it: '🇮🇹' };
export const SECTIONS = ['welcome', 'history', 'rules', 'roomservice', 'services', 'laundry', 'minibar', 'wines', 'ext'];
